import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {

  name = sessionStorage.getItem('name');
  MSMEId = sessionStorage.getItem('userId');
  isDrop: boolean = false;
  eventCount: { totalRecords: number, enrolledSuccessfully: number } = { totalRecords: 0, enrolledSuccessfully: 0 };


  totalEvents = 0;
  enrolledSuccessfully = 0;
  totalGrievances = 0;
  disposedGrievances = 0;
  pendingGrievances = 0;
  rejectedGrievances = 0;
  participantsAttended = 0;
  userType: string | null = null;
  filePath: string = '';
  fileName: string = '';


  private manualFileMap = {
    MSME: {
      path: 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-MSME.pdf'
    },
    IA: {
      path: 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-IA.pdf'
    }
  };
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastrService: ToastrService) { }

 
  ngOnInit(): void {
    this.GetEventCounts();
    //This code is written for to show user manual
    this.route.paramMap.subscribe(params => {
      const menuId = params.get('id');
      //console.log('Came from menu with ID:', menuId);

      this.userType = sessionStorage.getItem('UserType')?.toUpperCase() || null;
      if (menuId === 'usermanual' && this.userType) {
        this.viewManual(this.userType as 'MSME' | 'IA');
      }
    });
  }


  viewManual(manualType: 'MSME' | 'IA') {
    const manual = this.manualFileMap[manualType];

    if (manual) {
      this.filePath = manual.path;
      this.fileName = manual.name;

      this.apiService.getFilePreview(this.filePath).subscribe({
        next: (fileUrl) => {
          const dialogRef = this.dialog.open(PreviewfileComponent, {
            width: '1200px',
            height: '80%',
            data: {
              fileUrl,
              fileName: this.fileName
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.router.navigate(['/msmeuserdashboard']);
          });
        },
        error: (err) => {
          console.error('Error loading file preview:', err);
        }
      });
    } else {
      console.warn('Manual not found for type:', manualType);
    }
  }

  GetEventCounts() {
    let Id: string = sessionStorage.getItem('userId')!;
    let MSMEId: number = parseInt(Id, 10);
    var dtoMSMEId = { MSMEId: MSMEId };
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEDASHBOARDCOUNTS, dtoMSMEId )
      .subscribe((result) => {
        if (result.status) {
          this.totalEvents = result.data.totalEvents;
          this.enrolledSuccessfully = result.data.enrolledSuccessfully;
          this.totalGrievances = result.data.totalGrievances;
          this.disposedGrievances = result.data.disposedGrievances;
          this.pendingGrievances = result.data.pendingGrievances;
          this.rejectedGrievances = result.data.rejectedGrievances;
          this.participantsAttended = result.data.participantsAttended;
        }
      });
  }  

  CardRedirection(event: any) {
    //const buttonId = event.target.id;
    const buttonId = (event.currentTarget as HTMLElement).id;
    switch (buttonId) {
      case 'btnTotalEvents':
        this.commonService.searchText = '';
        this.router.navigate(['/vieweventlist']);
        break;
      case 'btnEnrolledSuccessfully':
        this.commonService.searchText = 'EnrolledSuccessfully';
        this.router.navigate(['/vieweventlist']);
        break;
      case 'btnAttendedEvents':
        this.commonService.searchText = 'AttendedSuccessfully';
        this.router.navigate(['/vieweventlist']);
        break;
      case 'btnTotalGrievances':
        this.commonService.searchText = '';
        this.router.navigate(['/grievanceDashboard']);
        break;
      case 'btnDisposedGrievances':
        this.commonService.searchText = 'Disposed';
        this.router.navigate(['/grievanceDashboard']);
        break;
      case 'btnPendingGrievances':
        this.commonService.searchText = 'Pending';
        this.router.navigate(['/grievanceDashboard']);
        break;
      case 'btnRejectedGrievances':
        this.commonService.searchText = 'Rejected';
        this.router.navigate(['/grievanceDashboard']);
        break;
        
      default:
        window.location.reload();
        break;
    }
  }

}
